const UserPreferenceKeys = {
  USER_PREFERENCE: "User Preference",
  TIMEZONE_TITLE: "Time Zone Settings",
  UPDATE_SUBMIT_SUCCESS_MSG: "Timezone settings updated successfully.",
  TIMEZONE: "Time Zone",
  SUPPORT_DST: "Support Daylight Saving Time (DST)?"
}
export default UserPreferenceKeys
